<template>
  <div id="root" style="background-color: white; padding: 0px;margin: 0px; position: relative; cursor: pointer;">

    <!--Map Container-->
    <div id="map" style="width: 100%; cursor: pointer;"></div>

    <!--Map Legend 图例-->
    <map-legend  @layoutupdate="layoutupdate" id="mapLegnt" :legends="mapLegends" v-if="mapLegendsVisible" ></map-legend>

    <!--Map Tools 地图顶部右侧的工具扩展-->
    <map-tools ref="refMapTools" id="mapTools" @mptClick="mptClick" v-if="toolsVisible">
      <template slot="extentSlot">
        <slot name="mapToolsExtentSlot" ></slot>
      </template>
      <template slot="bottomSlot">
        <slot name="mapToolsBottomSlot" ></slot>
      </template>
    </map-tools>

    <!--NavBar 地图顶部左侧-->
    <div id="navBarStyle">
      <slot name="navBar" ></slot>

    </div>

    <!--复位 - 地图右下角-->
    <!--<el-button type="primary" icon="el-icon-map-location" size="medium" circle id="mapCenter" @click="resetMapCenter" v-if="rightBootomNavButtonVisible"></el-button>-->

    <!--Popup 属性对话框-->
    <div id="popup" class="ol-popup">
      <div id="popup-content" class="popup-content">
        <div class="pop_header">
          <span>{{weather_site}}</span>
          <a href="#" id="popup-closer" class="ol-popup-closer"></a>
        </div>

        <div v-for="(item,item_index) in xqds_rainfull_list" :key="item_index">
          <div class="popupcell_rain">
            <span class="col_day">{{item.date}}</span>
            <span style="background-color: transparent;">{{item.rainFall?item.rainFall:(item.rainfall?item.rainfall:0)}} mm</span>
          </div>
        </div>

      </div>
    </div>

    <div  v-if="rainfallQueryResult != undefined"
      style="background-color:transparent;height: 40px;position: absolute;bottom: 0px;z-index: 0; width: 100%; border-top: solid 1px gray;">
      <div style="background-color:black;opacity: 0.6; height: 40px;position: absolute;bottom: 0px;z-index: 0; width: 100%;
      text-align: center; color: white;font-weight: bold;  line-height: 40px;font-size: 17px;">
      </div>

      <div style="height: 40px;position: absolute;bottom: 0px;z-index: 0; width: 100%;
      text-align: center; color: white; line-height: 40px;font-size: 17px;">
        {{rainfallQueryResult}}
      </div>


    </div>

  </div>
</template>

<script>

  import 'ol/ol.css'
  import View from 'ol/View'
  import Map from 'ol/Map'
  import {FullScreen} from 'ol/control'
  import ZoomSlider from 'ol/control/ZoomSlider'
  import {defaults} from 'ol/interaction'

  import {TDM_LAYER_VEC_C,TDM_LAYER_CVA_C,TDM_LAYER_IMG_C,TDM_LAYER_CIA_C,TDM_LAYER_IBO_C} from "./common/constant"
  import getLayerSource from "./common/layerSource"

  //地图组件
  import mapLegend  from "./MapLegend"
  import mapTools from "./MapTools"
  //引入地图工具操作类
  import {
    mu_getConvertFeaturnCoodinate,
    mu_setLayerIndex,
    mu_readLayerByName,
    mu_clearMeasureOverlay,
    mu_setLayerVisible,
    mu_setMapCenter,
    mu_addVectorMarkerLayer,
    mu_printMapLayers,
    mu_addSingleMarker,mu_addSingleMarkerWithOptioanlParams,
    mu_clearVectorMarkerLayer,
    mu_dynamicWMSLayers,              //动态图层
    mu_readFeaturnCoodinate} from "./common/MapUtils"
  import {heatmapLoading_test} from './common/heatmap'
  //PopupLayer
  import Overlay from 'ol/Overlay';
  //

  // 用来添加相关文字描述的
  import Fill from 'ol/style/Fill'
  //距离测量相关
  import Draw from 'ol/interaction/Draw'
  import {unByKey} from 'ol/Observable';
  import {getArea, getLength} from 'ol/sphere';
  import {LineString, Polygon} from 'ol/geom';
  import {Circle as CircleStyle, Stroke, Style} from 'ol/style';
  import {Vector as VectorSource} from 'ol/source';
  import {Vector as VectorLayer} from 'ol/layer';
  import GeoJSON from 'ol/format/GeoJSON';
  import {station_rainfall} from "@/api/index"


  let geojsonData_China = require("./china_boundary.json");
  //let geojsonData_China = require("./jiuduan.json");
  //let geojsonData_China = require("./countriesgeo");

  import AppConfig from "../../view/BSD/AppConfig";

  export default {
    name: "IHMap",
    components:{mapLegend,mapTools},
    props:{
      defaultCenter:{type: Array, default:()=>[109.00,36.040]}, //地图模块默认坐标中心，
      defaulZoom: {type: Number, default: 5},                  //默认缩放程度
      zoomSlider: {type: Boolean, default: false},             //是否显示缩放Slider
      fullScreen: {type: Boolean, default: false},             //是否全屏显示
      //Child Components property
      mapLegends:null,                                         //地图图例,可以在外部修改
      toolsVisible: {type: Boolean, default: true},
      mapLegendsVisible: {type: Boolean, default: true},

      //业务相关变量
      xqds_rainfull_list:[]


    },
    data(){
      return{
        MPLayers:[],                    //地图图层
        map:null,                       //地图对象
        view:null,                      //地图视图
        vectorMarkerLayer:null,         //地图Marker标注图层
        overLayPopup:null,              //地图用于Popup操作的图层
        rightBootomNavButtonVisible:false,
        //地图测量相关变量
        meansure_source:undefined,
        meansure_vector:undefined,
        meansure_draw:undefined,
        //popup 属性
        weather_site:"降雨监测点名称1",
        geojsonObject:null,
        selectedRainfallLayerName:undefined,
        //点击降雨图层后查询的降雨量信息
        rainfallQueryResult:undefined,
      }
    },

    mounted()
    {

      /****************************************************************************************************************
       * Popup
       * */
      var popup_container = document.getElementById("popup");
      var popup_closer = document.getElementById("popup-closer");
      //var popup_content = document.getElementById("popup-content");
      const _overLayPopup = new Overlay({
        olName:'overlay_popup',
        element: popup_container,
        autoPan: true,
        autoPanAnimation: {duration: 250}
      });

      this.overLayPopup = _overLayPopup;
      popup_closer.onclick = function() {
        _overLayPopup .setPosition(undefined);
        popup_closer.blur();
        return false;
      };



      /****************************************************************************************************************
       * Map Object
       * */
      //Init map container height property
      document.getElementById("map").style.height = document.body.clientHeight+"px";

      //Loading basic map layers
      this.MPLayers.push(TDM_LAYER_VEC_C,TDM_LAYER_IMG_C,TDM_LAYER_CIA_C);

      //添加国家边界 - geojson
      let chinaBorder = new VectorLayer({
        source: new VectorSource({
          features:new GeoJSON().readFeatures(geojsonData_China)
        }),
        style:new Style({
          stroke: new Stroke({ //边界样式
            color: '#FFA500',
            width: 2.0
          })
        })
      });
      chinaBorder.olTag ="boundary_country";
      this.mapboundaryLayer = chinaBorder;
      this.mapboundaryLayer.setVisible(true)
      chinaBorder.setZIndex(22);
      this.MPLayers.push(chinaBorder);


      //Process layer's init visible property
      TDM_LAYER_VEC_C.setVisible(false);

      let appkey = this.$route.query.appkey
      //Loading extension layers
      let businessLayers =getLayerSource(appkey);
      this.MPLayers.push(...businessLayers);

      var source = new VectorSource();
      this.meansure_source = source;
      var vector = new VectorLayer({
        source: source,
        style: new Style({
          fill: new Fill({
            color: 'rgba(255, 255, 255, 0.2)',
          }),
          stroke: new Stroke({
            color: '#ffcc33',
            width: 2,
          }),
          image: new CircleStyle({
            radius: 7,
            fill: new Fill({
              color: '#ffcc33',
            }),
          }),
        }),
      });
      vector.name="VectorDrawLayer"; //测距绘制图层
      this.meansure_vector = vector;
      this.MPLayers.push(vector);//添加至地图图层



      //Create Map Container Instance
      this.map = new Map({
        layers:this.MPLayers,
        target:'map',
        view:new View({
          center:this.defaultCenter,
          projection:"EPSG:4326",
          zoom:this.defaulZoom
        }),
        interactions:new defaults({  //屏蔽掉双击地图放大的动作
          doubleClickZoom:false
        })
      });

      //添加地图标注Layer并返回赋值
      this.vectorMarkerLayer = mu_addVectorMarkerLayer(this.map);
      console.log("print all the map layers");
      //打印所有图层,也可以关闭打印
      mu_printMapLayers(this.map);


      //ZoomSlider visible control
      //if(this.zoomSlider) {this.map.addControl(new ZoomSlider());}
      //FullScreen visible control
      if(this.fullScreen) {this.map.addControl(new FullScreen());}

      // 将弹窗添加到 map 地图中
      this.map.addOverlay(this.overLayPopup);


      /****************************************************************************************************************
       * Map Event
       * */
      //Add Map Event
      this.map.on('singleclick', evt =>
      {
        console.log(" ");
        console.log("this.selectedRainfallLayerName = ",this.selectedRainfallLayerName);
        //
        //
        const  mapToolActiveIndex = this.$refs.refMapTools.activeIndex;//地图工具栏活动索引
        console.log("map click && map tool index = ",mapToolActiveIndex);
        const selectedObject =  this.map.forEachFeatureAtPixel(evt.pixel, (feature,layer) => {return {feature,layer};}, {hitTolerance: 50});
        console.log(selectedObject);
        if(mapToolActiveIndex!=1) {
          console.log("Not Point Query Action && retun");

          let stationLayer_SK = mu_readLayerByName(this.map, "西气东输站厂阀室_SKJY");
          let stationLayer_YB = mu_readLayerByName(this.map, "西气东输站厂阀室_FCTS");
          if (stationLayer_SK.getVisible() == false && stationLayer_YB.getVisible() == false) {
            return;
          }
        }

        //查询降雨图层降雨降雨量信息
        if(this.selectedRainfallLayerName && mapToolActiveIndex==1){
          this.rainfallLayerFeatureInfoQuery(evt);
        }

        if(selectedObject)
        {
          console.log(selectedObject);
          const {feature:selectedFeature} = selectedObject;
          if(selectedFeature) {

            const markValues = selectedFeature.values_;
            console.log("markValues = ",markValues);
            const mType = markValues.mType;
            if(mType=="mapMarker") {
              let featurenCoordinate =mu_readFeaturnCoodinate(this.map,selectedFeature,0,-38);
              this.overLayPopup .setPosition(featurenCoordinate);
            }
            else if(mType=="rainfullStation")////站厂阀值点的
            {
              let featurenCoordinate =mu_readFeaturnCoodinate(this.map,selectedFeature,0,-38);
              //popup_content.innerHTML = '<p class="mmc">You clicked here:</p>'; //
              this.overLayPopup .setPosition(featurenCoordinate);
            }
          }
        }else {
          console.log("selectedFeatures  = no");
          _overLayPopup.setPosition(undefined);
          popup_closer.blur();
        }


        //查询是否有站厂阀室的图层
        let rainfullStaionLayer =  mu_readLayerByName(this.map,"西气东输站厂阀室_SKJY");
        let rainfullStaionLayer_visible = rainfullStaionLayer.getVisible();
        console.log("西气东输站厂阀室_SKJY::visible = ",rainfullStaionLayer_visible);
        if(rainfullStaionLayer!=null && rainfullStaionLayer_visible)
        {
          console.log("西气东输站厂阀室_SKJY != NULL && visible = true");
          this.mapFeatureInfoQuery(evt,rainfullStaionLayer,"西气东输站厂阀室_SKJY");
        }


        //查询是否有站厂阀室的图层
        let rainfullStaionLayer_fcts =  mu_readLayerByName(this.map,"西气东输站厂阀室_FCTS");
        let rainfullStaionLayer_visible_fcts = rainfullStaionLayer_fcts.getVisible();
        console.log("西气东输站厂阀室_FCTS::visible = ",rainfullStaionLayer_visible_fcts);
        if(rainfullStaionLayer_fcts!=null && rainfullStaionLayer_visible_fcts)
        {
          console.log("西气东输站厂阀室_FCTS != NULL && visible = true");
          this.mapFeatureInfoQuery(evt,rainfullStaionLayer_fcts,"西气东输站厂阀室_FCTS");
        }


      });

      /**
       * @description 地图视图范围改变后触发的动作. 1。主要是关闭地图的popup属性弹框
       * */
      this.map.getView().on('change:resolution',function () {
        //Hidden Popup Element after map's resolution changed
        _overLayPopup.setPosition(undefined);
        popup_closer.blur();
      });//checkZoom为调用的函数

    },
    methods: {

      EXUpdateSelectedFainfallLayerName(layer_name){
        this.selectedRainfallLayerName = layer_name;
      },

      /**
       * headmap
       * */
      EXHeatmapLoading:function(){
        heatmapLoading_test(this.map);
      },

      EXPrintMapLayers:function() {
        mu_printMapLayers(this.map);
        let slayer = mu_readLayerByName(this.map, "VecterLayer_GeoJSON");
        if (slayer)
        {
          let _features = slayer.getSource().getFeatures();
          console.log(_features);
          let l_geojson = new GeoJSON();
          let obj = l_geojson.writeFeatures(_features);
          console.log(obj);
        }
      },
      /**
       * @description 加载GEOJSON格式文件
       * */
      EXGeojson:function(){

        const  geojson_vectorLay = mu_readLayerByName(this.map,"VecterLayer_GeoJSON");
        if(geojson_vectorLay!=undefined)
        {
          console.log("geojson_layer is exist & remove it");
          this.map.removeLayer(geojson_vectorLay);
          return;
        }
        console.log("geolayer is not exist && load it");



        let _geojson = new GeoJSON();
        let _srouce = new VectorSource({
          url: AppConfig.minio_server+'/map/geo.geojson',
          format: _geojson,
        });

        var vectorLayer = new VectorLayer({
          name:"VecterLayer_GeoJSON",

          //加载网络数据
          source: _srouce,
          //https://openlayers.org/en/latest/examples/data/geojson/countries.geojson

          //通过Features的方式
          // source: new VectorSource({
          //   features: (new GeoJSON({featureProjection: 'EPSG:4326'})).readFeatures(this.geojsonObject),
          // }),

          style: function (feature)
          {
            const level = feature.get("level");
            let  fill_color = null;
            if(level==1) {
              fill_color = "blue";
            }else if(level==2) {
              fill_color = "green";
            }else if(level==3) {
              fill_color = "yellow";
            }else if(level==4) {
              fill_color = "orange";
            }else if(level==5) {
              fill_color = "red";
            }

            //style.getText().setText(feature.get('creator'));
            let _style = new Style({
              fill: new Fill({
                color: fill_color
              }),
              // stroke: new Stroke({
              //   color: "white",
              //   width: 1
              // })
            });
            return [_style]

          },
        });

        vectorLayer.name = "VecterLayer_GeoJSON";
        this.map.addLayer(vectorLayer);
      },






      /**
       * 根据图层名称控制其可见度
       * @param {string} layerName 图层名称
       * @param {boolean} visible 可见性
       * */
      setLayerVisible:function(layerName,visible) {
        mu_setLayerVisible(this.map,layerName,visible);
        this.overLayPopup.setPosition(undefined);
      },

      setLayerIndex:function(layer_name,layer_index) {
        console.log("setLayerIndex = ",layer_index);
        let selectedLayer =mu_readLayerByName(this.map,layer_name);
        if(selectedLayer) {
          console.log("setLayerIndex = object");
          selectedLayer.setZIndex(layer_index);
        }
        else {
          console.log("setLayerIndex = null");

        }
      },
      /**
       * @description 动态WMS图层
       * @param {object}  param
       * */
      dynamicWMSLayer:function(options)
      {
        /**
         * options 对象参数
         * @param {string} name                 图层名称
         * @param {string} server               服务地址
         * @param {string} code                 服务编码
         * @param {boolean} visible             图层可见性
         * */
        console.log("dynamicWMSLayer::data nn = ",options);
        mu_dynamicWMSLayers(this.map,options);
      },

      /**
       * @description 定位地图的中心
       * @param {Array} [longitude,latitude] 地图中心
       * */
      moveToCenter:function(center) {
        mu_setMapCenter(this.map,center,this.defaulZoom);
      },

      /**
       * @descriptiong 给地图添加标注
       * */
      addMarker(lon,lat) { //给地图添加标注
        mu_addSingleMarker(this.map,this.vectorMarkerLayer,lon,lat);
      },



      /**
       * @description 清除地图图层
       * */
      clearMarkerVectorLayer() { //Remove all features from the source of vector marker layer
        mu_clearVectorMarkerLayer(this.vectorMarkerLayer);
        //remove the Popup Element Object
        this.overLayPopup .setPosition(undefined);
      },

      /**
       * @description 地图复位
       * */
      resetMapCenter(){
        mu_setMapCenter(this.map,this.defaultCenter,this.defaulZoom);
      },
      /**
       * 设置地图中心
       * */
      setMapCenter(center,{zoom=12})
      {
        this.map.getView().setZoom(zoom);
        this.map.getView().setCenter(center);
      },

      setLayerZIndex(layerName,zIndex){
        mu_setLayerIndex(this.map,layerName,zIndex);
      },







      /**
       * @description 地图工具栏按钮的操作
       * */
      mptClick(maptool) {
        if(maptool=="delete")
        {
          this.clearMarkerVectorLayer();
          this.measure_overlay_clear();
        }
        else if(maptool=="fullMap")
        {
          this.resetMapCenter();//
        }
        else if(maptool=="mLine")
        {
          this.measure_clean();
          this.measure(this.map,'LineString');
          document.getElementById('map').style.cursor='crosshair';
        }
        else if(maptool=="mPolygon")
        {
          this.measure_clean();
          this.measure(this.map,"area");
          document.getElementById('map').style.cursor='crosshair';
        }
        else if(maptool=="query")
        {
          this.measure_clean();
          document.getElementById('map').style.cursor='pointer';
        }
        else if(maptool=="pan")
        {
          this.measure_clean();
          document.getElementById('map').style.cursor='move';
        }
      },


      /**
       * @description 切换测量模式下初始初始化工作
       * */
      measure_clean()
      {
        if(this.meansure_draw!=undefined) {
          console.log("measure clear");
          this.map.un('pointermove', this.PointerMoveHandler);    //解除地图事件与响应函数的绑定关系
          this.map.removeInteraction(this.meansure_draw);
          this.meansure_draw = undefined;
        }
        this.measure_overlay_clear();
      },





      /*****************************************************************************************************************
       * 添加测量工具
       * */
      measure(map, measureType) {
        this.measure_clean();


        var sketch;                   //存储绘制的地图要素
        var helpTooltipElement;       //开始操作之前的提示用语
        var helpTooltip;              //Overlay to show the help messages.  @type {module:ol/Overlay}

        var measureTooltipElement;    //The measure tooltip element.@type {Element} 测量状态下的提示语句
        var measureTooltip;           //Overlay to show the measurement.  @type {module:ol/Overlay}

        var continuePolygonMsg ='<span  style="color:red;background-color: #999999;padding: 5px;border-radius: 3px;font-size: 12px;color: white;height: 20px;line-height: 20px;">1继续点击绘制多边形</span>';
        var continueLineMsg = '<span  style="color:red;background-color: #999999;padding: 5px;border-radius: 3px;font-size: 12px;color: white;height: 20px;line-height: 20px;">继续点击绘制线</span>';
        var helpMsg = '<span  style="color:red;background-color: #999999;padding: 5px;border-radius: 3px;font-size: 12px;color: white;height: 20px;line-height: 20px;">请点击开始绘制</span>';


        this.PointerMoveHandler = function (evt)
        {
          if (evt.dragging) {return;}
          if (sketch) /** @type {string} */
          {
            var geom = (sketch.getGeometry());
            if (geom instanceof Polygon) {                  //绘制多边形
              helpMsg = continuePolygonMsg;                 //继续点击绘制多边形，绘制图形过程中的提示性文字
            } else if (geom instanceof LineString) {        //绘制线
              helpMsg = continueLineMsg;                    //继续点击绘制线
            }
          }
          helpTooltipElement.innerHTML = helpMsg;
          helpTooltip.setPosition(evt.coordinate);
          helpTooltipElement.classList.remove('hidden');    //取消隐藏开始显示
        };

        map.on('pointermove', this.PointerMoveHandler);//鼠标移动事件
        map.getViewport().addEventListener('mouseout', function () //鼠标移出视图事件
        {
          helpTooltipElement.classList.add('hidden');
        });
        //距离测量
        var formatLength = function (line) {
          console.log("formatLength = ",line);

          var length = getLength(line,{projection:'EPSG:4326'});
          var output;
          if (length > 100) {
            output = (Math.round(length / 1000 * 100) / 100) + ' ' + 'km';
          } else {
            output = (Math.round(length * 100) / 100) + ' ' + 'm';
          }
          return output;
        };
        //面积测量
        var formatArea = function (polygon) {
          var area = getArea(polygon,{projection:'EPSG:4326'});
          var output;
          if (area > 10000) {
            output = (Math.round(area / 1000000 * 100) / 100) + ' ' + 'km<sup>2</sup>';
          } else {
           output = (Math.round(area * 100) / 100) + ' ' + 'm<sup>2</sup>';
          }
          return output;
        };
        //地图添加绘图要素
        var _this = this;
        function addInteraction()
        {
          var type = (measureType == 'area' ? 'Polygon' : 'LineString');
          _this.meansure_draw = new Draw({
            source: _this.meansure_source,
            type: type,
            style: new Style({
              fill: new Fill({
                color: 'rgba(255, 255, 255, 0.8)'
              }),
              stroke: new Stroke({
                color: 'rgba(255, 0, 0, 1)',
                lineDash: [10, 10],
                width: 2
              }),
              image: new CircleStyle({
                radius: 5,
                stroke: new Stroke({
                  color: 'rgba(255, 0, 0, 1)'
                }),
                fill: new Fill({
                  color: 'rgba(255, 255, 255, 0.7)'
                })
              })
            })
          });
          map.addInteraction(_this.meansure_draw);

          createMeasureTooltip();
          createHelpTooltip();

          var listener;
          _this.meansure_draw.on('drawstart',             //开始绘制 - 点击编辑按钮后,第一次点击鼠标触发
            function (evt) {
              sketch = evt.feature;                       //绘制的对象
              var tooltipCoord = evt.coordinate;
              listener = sketch.getGeometry().on('change', function (evt) { //添加绘制改变事件
                var geom = evt.target;
                var output;
                if (geom instanceof Polygon) {
                  output = formatArea(geom); //计算面积
                  tooltipCoord = geom.getInteriorPoint().getCoordinates();
                } else if (geom instanceof LineString) {
                  output = formatLength(geom);//计算长度
                  tooltipCoord = geom.getLastCoordinate();
                }
                measureTooltipElement.innerHTML = "<p style='font-weight: bold;font-size: 17px;color: red;'>"+output+"</p>"; //渲染结果到UI
                measureTooltip.setPosition(tooltipCoord); //重新修改计算结果显示的位置
              });
            }, this);
          //结束绘制 - 双击鼠标
          _this.meansure_draw.on('drawend', function () {
              measureTooltipElement.className = 'tooltip tooltip-static';
              measureTooltip.setOffset([60, 0]);

              sketch = null;
              measureTooltipElement = null;
              createMeasureTooltip();
              unByKey(listener);
              //map.un('pointermove', pointerMoveHandler);
              //map.removeInteraction(draw);
              //helpTooltipElement.classList.add('hidden');
            }, this);


        }

        //添加开始之前的提示, 请点击开始绘制
        function createHelpTooltip()
        {
          if (helpTooltipElement) {
            helpTooltipElement.parentNode.removeChild(helpTooltipElement);
          }
          helpTooltipElement = document.createElement('div');
          helpTooltipElement.className = 'tooltip hidden';

          helpTooltip = new Overlay({
            olName:'measure_HelpTooltip',
            element: helpTooltipElement,
            offset: [15, 0],
            positioning: 'center-left'
          });
          map.addOverlay(helpTooltip);


        }

        //添加测试过程中的提示
        function createMeasureTooltip()
        {
          if (measureTooltipElement) {
            measureTooltipElement.parentNode.removeChild(measureTooltipElement);
          }
          measureTooltipElement = document.createElement('div');
          measureTooltipElement.className = 'tooltip tooltip-measure';

          console.log("createMeasureTooltip::add overlay");
          measureTooltip = new Overlay({
            olName:'measure_MeasureTooltip',
            element: measureTooltipElement,
            offset: [60, 0],
            positioning: 'bottom-center'
          });
          map.addOverlay(measureTooltip);
        }

        // 量测调用
        addInteraction();
      },

      /**
       * 清除测量结果
       * 2020年8月10日12:55:45
       * */
      measure_overlay_clear(){
        console.log("features clear");
        mu_clearMeasureOverlay(this.map,"measure_MeasureTooltip");
        mu_clearMeasureOverlay(this.map,"measure_HelpTooltip");
        this.meansure_source.clear();
      },




      rainfallLayerFeatureInfoQuery(event)
      {
        console.log("rainfallLayerFeatureInfoQuery::~~~~");
        const  map_layer = mu_readLayerByName(this.map,this.selectedRainfallLayerName);
        var view = this.map.getView();
        var viewResolution = view.getResolution();
        var source = map_layer.getSource();
        console.log("source = ",source);

        var url = source.getFeatureInfoUrl(
          event.coordinate,
          viewResolution,
          view.getProjection(), {'INFO_FORMAT': 'application/json', 'FEATURE_COUNT': 50});

        this.axios.get(url).then((response)=>{
          console.log("rainfallLayerFeatureInfoQuery::response.data = ",response.data);
          const selectedFeatures =response.data.features;
          let rainfall_max =undefined;
          for(let i=0;i<selectedFeatures.length;i++)
          {
            let selectedFeature = selectedFeatures[i];
            let selectedFeature_properties = selectedFeature.properties;
            let rainfallValue = selectedFeature_properties.NAME;
            if(rainfall_max ==undefined || rainfall_max<rainfallValue){
              rainfall_max = rainfallValue;
            }
          }
          if(rainfall_max!=undefined) {
            let rainfallData =  "经度："+event.coordinate[0]+" " +"纬度："+event.coordinate[1]+"   /   " +"   最大降雨量："+rainfall_max+" (毫米)";
            this.rainfallQueryResult = rainfallData;
            //this.$emit("updateRainallQueryData",rainfallData);
          }
          else {
            this.rainfallQueryResult = undefined;
          }

        });
      },





      /**
       * 地图图层要素信息查询
       * 2020年8月19日16:35:28
       * */
      mapFeatureInfoQuery(map_click_event,map_layer,layer_name=undefined)
      {
        console.log("MapClick::MapFeatureInfoQuery");
        const event = map_click_event;
        //console.log("map.singleclick = ",event);
        var view = this.map.getView();
        var viewResolution = view.getResolution();
        var source = map_layer.getSource();
        //console.log("source = ",source);

        var url = source.getFeatureInfoUrl(
          event.coordinate,
          viewResolution,
          view.getProjection(),
          {'INFO_FORMAT': 'application/json', 'FEATURE_COUNT': 50});

        //console.log("mapFeatureInfoQuery::url = ",url);
        url = url.replace("http://218.241.129.181:8010/","/zdha_geoserver/");
        //console.log("mapFeatureInfoQuery::new_url = ",url);

        this.axios.get(url).then((response)=>{
          //console.log("response.data = ",response.data);
          const selectedFeatures =response.data.features;
          if(selectedFeatures.length>0) {
            const selectedFeature = selectedFeatures[0];
            const selectedFeature_properties = selectedFeature.properties;
            console.log("layer_name = ",layer_name," && selectedFeature = ", selectedFeature);

            //**********************************************************************************************************
            //西气东输项目
            if (layer_name.indexOf("西气东输站厂阀室")==0)
            {
              let feature_properties_id = selectedFeature.id;
              let feature_properties_id_ary = feature_properties_id.split(".");
              let feature_gid  = feature_properties_id_ary[1];

              //修改gid取值
              let  featureProperties = selectedFeature.properties;
              console.log("selectedFeatureProperties = ",featureProperties);
              feature_gid = featureProperties.gid;

              if(layer_name.substring(layer_name.length-4)=="SKJY") {
                console.log("layerName = 西气东输站厂阀室 && 实况降雨图层查询");
                this.app_xqds_staion_rainfullQuery(layer_name,feature_gid,1);
                this.weather_site ="[实况降雨] "+ selectedFeature_properties["名称"];
              }else if(layer_name.substring(layer_name.length-4)=="FCTS") {
                console.log("layerName = 西气东输站厂阀室 && 预报降雨图层查询");
                this.app_xqds_staion_rainfullQuery(layer_name,feature_gid,2);
                this.weather_site ="[预报降雨] "+ selectedFeature_properties["名称"];
              }

            }

            //**********************************************************************************************************
            //其他项目



            //**********************************************************************************************************
            //Popup定位
            let featurenCoordinate =mu_getConvertFeaturnCoodinate(this.map,selectedFeature,0,-10);
            this.overLayPopup .setPosition(featurenCoordinate);
          }

        });
      },






      //****************************************************************************************************************
      //业务相关的接口 - 属于可删除的内容
      /**
         id: 0
         latitude: 23.2129835532
         logitude: 109.58964885
         stationName: "贵港分输清管站"
         type: "分输站"
       * */
      app_addStaionMarker(options) { //给地图添加标注
        //mu_addSingleMarker(this.map,this.vectorMarkerLayer,options.logitude,options.latitude,options.stationName);
        mu_addSingleMarkerWithOptioanlParams(this.map, this.vectorMarkerLayer, options.logitude,options.latitude,
          {attribute:options,mType:options.mType,markText:options.stationName});
        this.weather_site = options.stationName;
      },
      /**
       * 西气东输 - 站场阀室 - 实况降雨量
       * */
      app_xqds_staion_rainfullQuery(layer_name,station_id,type)
      {
        console.log("app_xqds_staion_rainfullQuery::station_id = ",station_id," &layer_name = ",layer_name,"&layer_name.substring(layer_name.length-5) = ",layer_name.substring(layer_name.length-4));
        station_rainfall({gId:station_id,type}).then(res=>{
          const resData = res.data;
          const rainfall_data = resData.data;
          console.log("rainfall_data = ",rainfall_data);
          this.xqds_rainfull_list = rainfall_data;
        })

      },


      layoutupdate(){
        document.getElementById("mapLegnt").style.bottom = '-200px';
      }






    }
  }
</script>


<style scoped lang="scss">
  //引入CSS变量文件，便于维护
  @import "./scss/mapStyle";
</style>



// WEBPACK FOOTER //
// src/components/map/IHMap.vue